import { render, staticRenderFns } from "./hzv1.vue?vue&type=template&id=60a78994&scoped=true"
import script from "./hzv1.vue?vue&type=script&lang=js"
export * from "./hzv1.vue?vue&type=script&lang=js"
import style0 from "./hzv1.vue?vue&type=style&index=0&id=60a78994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a78994",
  null
  
)

export default component.exports